import { SHOW_TOAST } from 'state/actionTypes';

export const successMessage = (
  message,
  description,
  timeout = 2000,
  options = {}
) => ({
  type: SHOW_TOAST,
  payload: {
    type: 'success',
    message,
    description,
    timeout,
    options,
  },
});

export const errorMessage = (
  message,
  description,
  timeout = 4000,
  options = {}
) => ({
  type: SHOW_TOAST,
  payload: {
    type: 'error',
    message,
    description,
    timeout,
    options,
  },
});
